import '../static/styles/style.css'
import {getGameState} from './services/GameState'
import {initMap, showMap} from './GameMap/GameMap'
import {initForest} from './Forest/Forest'
import {initMountain} from './Mountain/Mountain'

let gameState = getGameState()

const audio = new Audio();
const audioFiles = {
  map: '/sounds/help_bunny_map.wav',
  forest: '/sounds/help_bunny_forest.wav',
  mountain: '/sounds/help_bunny_mountain.wav',
}

let currentAudio = null

const initSound = () => {
  window.removeEventListener('keydown', initSound)
  playSound('map')
}

const playSound = (filename = 'map') => {
  if (filename !== currentAudio) {
    currentAudio = filename
    audio.pause()
    audio.src = audioFiles[currentAudio]
    audio.load()
    audio.loop = true;
    audio.play()
  }
}

const gameStep = (gameState) => {
  switch(gameState.currentLevel) {
    case 'map':
      initMap(() => {
        gameState = {
          ...gameState,
          currentLevel: 'forest'
        }
        gameStep(gameState)
      })
      break;
    case 'forest':
      playSound('forest')
      initForest(() => {
        gameState = {
          ...gameState,
          currentLevel: 'forest-map'
        }
        gameStep(gameState)
      })
      break
    case 'forest-map':
      playSound('map')
      showMap('forest', () => {
        gameState = {
          ...gameState,
          currentLevel: 'mountain'
        }
        gameStep(gameState)
      })
      break
    case 'mountain':
      playSound('mountain')
      initMountain(() => {
        gameState = {
          ...gameState,
          currentLevel: 'final-map'
        }
        gameStep(gameState)
      })
      break
    case 'final-map':
      playSound('map')
      showMap('mountain', () => {
        gameState = {
          ...gameState,
          currentLevel: 'final-map'
        }
      })
      break
  }
}



window.addEventListener('keydown', initSound)
gameStep(gameState)